import { useCallback, useState } from 'react'
import { logoutApi } from '@!/Api/externalPayment'
import { useErrorToast } from '../CoinPurchase/hooks/useErrorToast'

const LOGIN_URL = '/external_payment/login'

export const useLogout = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { showError } = useErrorToast()

  const logout = useCallback(async () => {
    if (isLoading) return
    setIsLoading(true)
    try {
      await logoutApi()
      window.location.href = LOGIN_URL
    } catch (error) {
      // 401エラー（未ログイン）の場合もログイン画面にリダイレクト
      if (error.response?.status === 401) {
        window.location.href = LOGIN_URL
        return
      }
      showError({
        title: 'エラー',
        errorMessage: '通信エラーが発生しました。再度お試しください。',
      })
      setIsLoading(false)
    }
  }, [isLoading, showError])

  return { logout, isLoading }
}
